module.exports = __webpack_public_path__ + "static/media/AbsinthePoster_Cropped.c488b124.jpg";